import { isFulfilled, isPending, isRejected } from "../../utils/redux/action-utils.js";
import { onFulfilled, onPending, onRejected } from "../../utils/redux/state-utils.js";
import { transientInitialState } from "./initial-state.js";
//#region src/redux/transient/extra-reducers.ts
var isActionFulfilled = (action) => isFulfilled(action, "transient");
var isActionPending = (action) => isPending(action, "transient");
var isActionRejected = (action) => isRejected(action, "transient");
var isSignOut = (action) => isFulfilled(action, "auth/signOut");
var onSignOut = (state) => {
	state.transients = transientInitialState.transients;
	state.isPending = transientInitialState.isPending;
	state.isRejected = transientInitialState.isRejected;
	state.errorMessage = transientInitialState.errorMessage;
};
var extraReducers = (builder) => {
	builder.addMatcher(isActionFulfilled, onFulfilled).addMatcher(isActionPending, onPending).addMatcher(isActionRejected, onRejected).addMatcher(isSignOut, onSignOut);
};
//#endregion
export { extraReducers };

//# sourceMappingURL=extra-reducers.js.map